import { render } from "./BaseModal.vue?vue&type=template&id=9d2fa662&scoped=true"
import script from "./BaseModal.vue?vue&type=script&lang=js"
export * from "./BaseModal.vue?vue&type=script&lang=js"

import "./BaseModal.vue?vue&type=style&index=0&id=9d2fa662&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d2fa662"]])

export default __exports__